import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { FlexBox } from "@/common/components/Box/FlexBox.tsx";

export function Draggable({ id, children }: { id: string, children: React.ReactNode }) {
  const { setNodeRef } = useDraggable({
    id,
  });

  return (
    <FlexBox
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
      ref={setNodeRef}
    >
      {children}
    </FlexBox>
  );
}
